import {
  AgentCreatePayload,
  AgentFilter,
  AgentGrid,
  AgentInfo,
} from '../agent.model';

export class SetAgents {
  static readonly type = '[Agent] Set Agents';
  constructor(public payload: Partial<AgentGrid>) {}
}

export class FetchAgents {
  static readonly type = '[Agent] Fetch Agents';

  constructor(public payload: AgentFilter) {}
}

export class UpdateAgentFilters {
  static readonly type = '[Agent] Update Filters';

  constructor(public payload: Partial<AgentFilter>) {}
}

export class FetchAgentInfo {
  static readonly type = '[Agent] Fetch Agent Info';

  constructor(public id: string | number) {}
}

export class InitializeAgentDropdowns {
  static readonly type = '[Agent] Initialize Agent Form Dropdowns';
}

export class CreateAgent {
  static readonly type = '[Agent] Create Agent';

  constructor(public payload: AgentCreatePayload) {}
}

export class UpdateAgent {
  static readonly type = '[Agent] Update Agent';

  constructor(public payload: Omit<AgentInfo, 'agentTypes'>) {}
}

export class DeleteAgent {
  static readonly type = '[Agent] Delete Agent';

  constructor(public ids: number[]) {}
}
